import Axios from 'axios';

import { SetStatusGlobal } from '../interface/Global';

import Env from './Env';

// Interface para resposta da API de login
interface LoginResponse {
    status: boolean;
    user?: {
        name: string;
        file: string;
        type_access: string;
    };
}

export async function CheckedLogin(): Promise<void> {

    try {
        const response = await Axios.post<LoginResponse>(Env.apiUrl, {
            type_page: 'check_login',
            token: localStorage.getItem('token')
        });

        if(response.data.status){
            // Salva no localStorage
            localStorage.setItem('user_name', localStorage.getItem('user_name') ?? '');
            localStorage.setItem('user_file', localStorage.getItem('user_file') ?? '');
            localStorage.setItem('token', localStorage.getItem('token') ?? '');

            SetStatusGlobal('dashboard', true);
            SetStatusGlobal('user_name', localStorage.getItem('user_name') ?? '');
            SetStatusGlobal('user_file', localStorage.getItem('user_file') ?? '');

        } else {
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_file');
            localStorage.removeItem('token');

            SetStatusGlobal('dashboard', false);
            SetStatusGlobal('user_name', '');
            SetStatusGlobal('user_file', '');
        }
        
    } catch (error) {
        SetStatusGlobal('dashboard', false);
    }
}